import {
  StyledErrorIcon,
  StyledIcon,
  StyledStatusIcon,
  StyledTextField,
  TextboxWrapper,
} from "./FormTextbox.styles"

export interface Props {
  label: string
  validationState: "ok" | "default" | "error"
  value?: string | number | null | undefined | readonly string[]
  onChange?: (e: any) => void
  type?: string
  helperText?: string
  disabled?: boolean
}

export default function FormTextbox(props: Props) {
  const safeValue = props.value ?? ""
  return (
    <TextboxWrapper>
      <StyledTextField
        label={props.label}
        value={safeValue}
        onChange={props.onChange}
        fullWidth
        inputProps={{
          style: {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "16px",
          },
        }}
        InputLabelProps={{
          shrink: true,
        }}
        type={props.type}
        helperText={props.helperText}
        disabled={props.disabled === undefined ? false : props.disabled}
        FormHelperTextProps={{
          style: {
            marginLeft: 0,
          },
        }}
      />
      {props.validationState && (
        <StyledIcon>
          {props.validationState === "ok" && <StyledStatusIcon />}
          {props.validationState === "error" && <StyledErrorIcon />}
        </StyledIcon>
      )}
    </TextboxWrapper>
  )
}
